import * as XLSX from 'xlsx';

const convertXLSXtoSafetyData = (binaryString) => {
  const bufferSize = 65001;
  const wb = XLSX.read(binaryString, { type: 'binary', codepage: bufferSize });
  const wsname = wb.SheetNames[0];
  const ws = wb.Sheets[wsname];
  const dataXls = XLSX.utils.sheet_to_json(ws);
  const safetyDataXls = JSON.parse(JSON.stringify(dataXls));
  return safetyDataXls;
};

export default convertXLSXtoSafetyData;